import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  product = null 
}) => {
  const siteName = 'Original Bull Biltong';
  const defaultTitle = 'Original Bull Biltong | Premium Australian Beef Biltong | 52% Protein';
  const defaultDescription = "Australia's #1 premium biltong. 52% protein, 100% Australian beef, air-dried using a 200-year-old South African recipe. Australian Made certified. Free shipping over $59.";
  const defaultImage = 'https://customer-assets.emergentagent.com/job_185b30bf-6e94-434b-8e3e-3ca910668034/artifacts/jlwf1bqr_OB%20Original%20-%20Signle%20pack%20.jpg';
  const baseUrl = 'https://originalbull.com';

  const seoTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;
  const seoUrl = url ? `${baseUrl}${url}` : baseUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={seoUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_AU" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seoUrl} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      
      {/* Product Schema for product pages */}
      {product && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.name,
            "image": product.image,
            "description": product.description,
            "sku": product.sku,
            "brand": {
              "@type": "Brand",
              "name": "Original Bull"
            },
            "offers": {
              "@type": "Offer",
              "url": seoUrl,
              "priceCurrency": "AUD",
              "price": product.price,
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/NewCondition"
            }
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
